import FormContainer from "../components/FormSteps/FormContainer";

const Onboarding = () => {
    return <FormContainer />;
};

export default Onboarding;